import React, { useCallback, useState } from 'react';
import axios from '../modules/api';
import http from '../modules/api';
import * as StyleUtil from '../modules/utils/StyleUtil';
import {Line} from 'react-chartjs-2';
import { NavLink, Link, Prompt } from 'react-router-dom';
import $ from 'jquery';
import Slider from "react-slick";
import plus_img from '../../resources/img/plus.svg';
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import CheckBox from '../modules/common/CheckBox';
import AiRecommendationCard from './component/AiRecommendationCard';

import ReactGA, { send } from 'react-ga';
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";
ReactGA.initialize('UA-78553461-8', {
    titleCase: false,
});

let window_scrollTop; // 스크롤 위치

let is_test_use = "";
if (document.domain.indexOf("127.0.0.1") >= 0 || document.domain.indexOf("otdeal.me") >= 0) {
    is_test_use = "Y";
}

export class AiRecommendationCardList extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            ai_algorithm_list: [],
            checked_list: [],
            filter_page_id: "-1",
            filter_ai_alias_type_cd: "",
            ai_algorithm_type_cd_list: [],

            filter_iframe_page_id: "",
            iframe_page_id_list: [
                {code_cd: "robomd_ai_main_page", code_name: "메인"},
                {code_cd: "robomd_ai_detail_page", code_name: "상세"},
                {code_cd: "robomd_ai_cart_page", code_name: "장바구니"},
                {code_cd: "robomd_ai_order_complete_page", code_name: "구매완료"},
            ],
        }
    }

    componentWillMount() {

    }

	componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const filter_iframe_page_id = params.get('filter_iframe_page_id') || "";
        const filter_ai_alias_type_cd = params.get('filter_ai_alias_type_cd') || "";
        if (filter_iframe_page_id || filter_ai_alias_type_cd) {
            this.setState({
                filter_iframe_page_id,
                filter_ai_alias_type_cd,
            }, () => {
                this.loadAiRecommendationList();
            });
        } else {    
            this.loadAiRecommendationList();
        }
        this.loaAaiAlgorithmTypeCdList();
    }

    componentDidUpdate() {
    }

    componentWillUnmount(e) {

    }

    /** AI 추천 알고리즘 타입 조회 */
    loaAaiAlgorithmTypeCdList () {
        this.setState({
            ai_algorithm_list : [],
        }, () => {
            http.get("/rest/shop/aiAlgorithmTypeCdList?"+is_test_use) 
            .then(res => {
                const list = res.data.list;
                this.setState({
                    ai_algorithm_type_cd_list : list
                });
            })
            .catch(error => {
            });
        });
    }

    /** AI 추천 알고리즘 목록 조회 */
    loadAiRecommendationList() {
        this.setState({
            ai_algorithm_list: [],
        }, () => {
            const params = {};

            if (this.state.filter_ai_alias_type_cd) {
                params.filter_ai_alias_type_cd = this.state.filter_ai_alias_type_cd;
            }

            if (this.state.filter_iframe_page_id) {
                params.filter_iframe_page_id = this.state.filter_iframe_page_id;
            }

            // 기존 is_test_use가 값 형태라면 이런 식으로 넣는 게 좋습니다.
            // 예: this.state.is_test_use === "Y"
            if (this.state.is_test_use) {
                params.is_test_use = this.state.is_test_use;
            }

            http.get("/rest/shop/aiRpAlgoritmList", {
                params: params
            })
            .then(res => {
                const list = res.data.list || [];

                this.setState({
                    ai_algorithm_list: list
                });
            })
            .catch(error => {
                console.error("AI 추천 알고리즘 목록 조회 실패", error);
            });
        });
    }

    onClickFilter(name) {
        this.setState({
            filter_ai_alias_type_cd: name
        }, () => {
            this.loadAiRecommendationList ();
        })
    }
    
    onClickPageFilter(name) {
        this.setState({
            filter_iframe_page_id: name
        }, () => {
            this.loadAiRecommendationList ();
        })
    }

    onClickButton(item) {
        // alert("/shop/rp/aiRecommendationForm/"+item.code_cd)
        window.location.href = "/shop/ai/rp/eventSetting?ai_algorithm_cd="+item.code_cd+"&ai_algorithm_type_code="+item.ai_alias_type_cd;
    }

    render() {
        return (
            <>
                <div id='common-page-wrapper' className="style_guide_v2">
                    <div className="app-container">
                        <h1 className="main-title">AI추천</h1>
                        <p className="main-description">
                            성장형 AI 자동결정을 추천받고 자주쓰는 AI업무환경을 관리하세요.
                        </p>
                        <div className="ai-card-filter-container" style={{marginBottom:"10px"}}>
                            <div className={"ai-card-filter "+(this.state.filter_ai_alias_type_cd == "" ? "active" : "")} onClick={() => this.onClickFilter("")}>전체 파트너</div>
                            {
                                this.state.ai_algorithm_type_cd_list.map((item, index) => {
                                    return <div className={"ai-card-filter "+(this.state.filter_ai_alias_type_cd == item.code_cd ? "active" : "")} onClick={() => this.onClickFilter(item.code_cd)}>{"AI로보MD "+item.code_name}</div>
                                })
                            }
                        </div>
                        <div className="ai-card-filter-container">
                            <div className={"ai-card-filter "+(this.state.filter_iframe_page_id == "" ? "active" : "")} onClick={() => this.onClickPageFilter("")}>전체 페이지</div>
                            {
                                this.state.iframe_page_id_list.map((item, index) => {
                                    return <div className={"ai-card-filter "+(this.state.filter_iframe_page_id == item.code_cd ? "active" : "")} onClick={() => this.onClickPageFilter(item.code_cd)}>{item.code_name}</div>
                                })
                            }
                        </div>
                        <div className="ai-card-container">
                            {/* <AiRecommendationCard
                            id="aiRecommendationCard_1"
                            title="AI로보MD제니"
                            subtitle="같은 브랜드 함께 구매한 상품"
                            summary="AI로보MD제니가 브랜드상품마다 함께 구매하거나 다음에 살 확률이 높은 상품을 추천해드려요."
                            details={`쇼핑몰의 소비자가 쇼핑할때 어떤 브랜드의 상품에 계속 관심을 가지는지 찾아보는 것을 좋아해요.<br/>
                            그래서 <b>상품마다 다른 상품을 함께 구매하는지와 다음에 어떤 것을 샀는지  모든 보시자의 2달간 주문데이터를 모두 다 찾아볼정도로 좋은 상품추천에 탁월한 재능이 있어요.</b><br/>
                            <font style="color:#0090FF">앞으로 제니가 매일 분석한 데이터로 상품마다 소비자가 함께 구매하거나<br/>
                            다음에 구매할 확율이 높은 같은 브랜드내의 인기상품을 추천해드릴거예요.</font><br/>
                            만약 함께 구매한 상품이 별로 없으셔도 걱정없어요!<br/>
                            1주안에 함께 구매할 상품이 없다면 다음에 산 상품을 추천하고 이중에 없다면<br/>
                            2주,3주,8주내에서  추천하고 부족하면 베스트상품을 추천해드릴거예요.<br/>`}
                            buttonText="시작하기"
                            detailImageUrl="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/ai_algorithm_character/jenny.png"
                            detailRightImageUrl="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/ai_algorithm_content_image/Group+22193.png"
                            /> */}
                            {
                                this.state.ai_algorithm_list.map((item, index) => {
                                    return (
                                        <AiRecommendationCard
                                            key={index}
                                            id={item.code_cd}
                                            title={item.ai_alias_type_title.replaceAll("{{ai_alias_type_name}}", item.ai_alias_type_name)}
                                            subtitle={item.code_name.replaceAll("{{ai_alias_type_name}}", item.ai_alias_type_name)}
                                            summary={item.title.replaceAll("{{ai_alias_type_name}}", item.ai_alias_type_name)}
                                            details={item.content.replaceAll("{{ai_alias_type_name}}", item.ai_alias_type_name)}
                                            buttonText={"시작하기"}
                                            detailImageUrl={item.sumnail_img_url}
                                            detailRightImageUrl={item.content_img_url}
                                            is_main_page_use={item.is_main_page_use}
                                            is_detail_page_use={item.is_detail_page_use}
                                            is_cart_page_use={item.is_cart_page_use}
                                            is_order_complete_page_use={item.is_order_complete_page_use}
                                            onClickButton={() => this.onClickButton(item)}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                {
					(this.state.confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({confirm_dialog_show_state: false});
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
					: ''
				}
                {
					(this.state.basic_dialog_show_state === true)
					? <BasicDialogV2
						content={this.state.basic_dialog_content}
						button_list={this.state.basic_dialog_button_list}
					/>
					: ''
				}
                {
                    (this.state.delete_dialog_show_state === true)
                        ? <ConfirmDialogV2
                            content={this.state.delete_dialog_content}
                            button_list={this.state.delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_period_title_content_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            title={ this.state.is_finish == 0 ? this.state.remain_date+"일 뒤 "+this.state.payment_cls_text+"이 종료됩니다. <br/> 기간을 연장하시겠습니까?" : this.state.payment_cls_text+"이 종료되었습니다. <br/> 기간을 연장하시겠습니까?" }
                            content={this.state.payment_cls_text + " 기간<br/>" +  this.state.start_date_format + " ~ " + this.state.end_date_format}
                            button_list={this.state.title_content_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_period_title_content_dialog_show_state: false});
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_delete_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            content={this.state.notice_delete_dialog_content}
                            button_list={this.state.notice_delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {/* {this.state.tutorial_dialog_state &&
					<TitleContentDialogV2
						title={"로보MD 진열 사용하러 가볼까요?"}
						content={"다양한 자동 진열기능을 사용해 보시고<br/>자동 진열되는 상품결과를 미리보고 체험하세요."}
						button_list={[
                            {
                                title: "진열기능보기",
                                type: "1",
                                event_method: () => {
                                    this.addMainList();
                                    //팝업 닫기
                                    this.setState({
                                        tutorial_dialog_state: false,
                                        notice_period_title_content_dialog_show_state : false,
                                    });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            },
                            {
                                title: "닫기",
                                type: "0",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({ tutorial_dialog_state: false });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            }
                        ]}
                        popup_close={() => {
                            this.setState({ tutorial_dialog_state: false });
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
				} */}
            </>
        )
    };
    
}